<script>
    import FormRow from "../../../components/FormRow.svelte";
    import FormColumn from "../../../components/FormColumn.svelte";
    import AddButton from "../../../components/buttons/AddButton.svelte";

    import Surgery from "./Surgery.svelte";

    export let surgeries = [];
    export let disabled = null;

    const handleAddSurgery = () => {
        surgeries.push({
            surgeryId: 0,
            addedByQuestionnaire: true,
            dateSurgery: null,
            isFurtherSurgery: false,
            surgeryImplants: [{ implantId: null }],
        });

        surgeries = [...surgeries];
        console.info("adding", surgeries)
    };

    const handleDeleteSurgery = (surgery) => {
        surgery.deleted = true;
        surgeries = [...surgeries];
        console.info("deleting", surgery, surgeries)
    };

    const initialise = () => {};

    initialise();
</script>

<div>
    <h3>List of Surgeries</h3>

    {#if surgeries && surgeries.length}
        {#each surgeries.filter((s) => !s.deleted) as surgery, index (surgery)}
            <Surgery
                {disabled}
                {surgery}
                on:delete={() => handleDeleteSurgery(surgery)}
            />
        {/each}
    {:else}
        <FormRow>
            <FormColumn>
                <p>No Surgeries Provided</p>
            </FormColumn>
        </FormRow>
    {/if}
</div>

<div class="confirmation-hide" style="margin-top: 26px;">
    <AddButton on:add={handleAddSurgery}>Add Surgery</AddButton>
</div>
